module.exports = __webpack_public_path__ + "a5ef81d3a9f6d5762ce6.worklet.js";